import React, { useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { exchangeOAuthCode } from "../../actions/auth";
import Modal from "../common/Modal/Modal";

export function OAuthCallback(props) {

    const location = useLocation();
    const [failed, setFailed] = useState(false);
    const status = useSelector(state => state.auth.status);

    useEffect(() => {
        const code = new URLSearchParams(location.search).get("code");
        if (!code) {
            setFailed(true);
            return;
        }
        props.exchangeOAuthCode(code).then((didSucceed) => !didSucceed && setFailed(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (status === "authenticated") {
        return <Redirect to="/dashboard" />;
    }

    return (
        <Modal slogan={true} className="oauth-callback">
            {failed ? (
                <p className="content2 text-center">
                    That sign-in link didn't work. <a href="#/login">Return to login</a> and try again.
                </p>
            ) : (
                <p className="content2 text-center">Signing you in...</p>
            )}
        </Modal>
    );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { exchangeOAuthCode })(OAuthCallback);
